import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type UserUnauthenticatedOAuthQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserUnauthenticatedOAuthQuery = { viewer: { __typename: 'Viewer', user: { __typename: 'User', id: string, currentUserRole: string | null } } | null };


export const UserUnauthenticatedOAuthQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User_UnauthenticatedOAuth_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentUserRole"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UserUnauthenticatedOAuthQueryQueryResult = Apollo.QueryResult<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>;

export function useUserUnauthenticatedOAuthQuery(
  baseOptions?: Apollo.QueryHookOptions<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>
) {
  return Apollo.useQuery<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>(
    UserUnauthenticatedOAuthQueryDocument,
    baseOptions
  );
}

export function useUserUnauthenticatedOAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>) {
  return Apollo.useLazyQuery<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>(
    UserUnauthenticatedOAuthQueryDocument,
    baseOptions
  );
}

export function useUserUnauthenticatedOAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>) {
  return Apollo.useSuspenseQuery<UserUnauthenticatedOAuthQuery, UserUnauthenticatedOAuthQueryVariables>(
    UserUnauthenticatedOAuthQueryDocument,
    baseOptions
  );
}
